import { z } from 'zod'

import { ChangeType } from './ChangeType'
import { SystemFeature } from './SystemFeature'

export const FeatureChange = z.object({
  id: z.string(),
  feature: SystemFeature,
  changeType: ChangeType,
  description: z.string()
})

export type FeatureChange = z.infer<typeof FeatureChange>
